export default {
  LOG_OUT ({ commit }) {
    // Delete user from store
    commit('REMOVE_USER')
    commit('REMOVE_TOKEN')

    // Delete cache from store
    commit('CLEAR_CACHE')

    // Delete user from local storage
    if (window.localStorage) {
      window.localStorage.removeItem('user')
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('globalConfig')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js